import React from 'react';

const ErrorMessage = () => {
    return (
      <div className="fixed top-4 left-4 bg-white shadow-xl rounded-lg p-6 max-w-sm animate-slideIn">
        <p className="text-lg text-gray-800 font-medium">
          Oops! Knappen ser ikke ut til å fungere 😅 
          <span className="block mt-2 text-pink-600">
            Kanskje du skal prøve en annen knapp? 
          </span>
        </p>
      </div>
    );
}

export default ErrorMessage;